/* 🤖 this file was generated by svg-to-ts */
export const matIconSignalWifiStatusbar4Bar: {
  name: 'signal-wifi-statusbar-4-bar';
  data: string;
} = {
  name: 'signal-wifi-statusbar-4-bar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0 0 12 4z"/></svg>`
};
